import { authTheme } from "../../data/auth/authTheme";

export const authInputClassName =
  "font-inter h-[52px] w-full rounded-xl border px-4 text-[15px] text-[#1B1B2F] placeholder:text-[#9CA3AF] focus:outline-none focus:ring-2";

export function applyAuthInputFocus(event) {
  event.currentTarget.style.borderColor = authTheme.accent;
  event.currentTarget.style.boxShadow = authTheme.accentFocusShadow;
}

export function applyAuthInputBlur(event) {
  event.currentTarget.style.borderColor = authTheme.inputBorder;
  event.currentTarget.style.boxShadow = "none";
}

export const authInputStyle = {
  backgroundColor: authTheme.inputBackground,
  borderColor: authTheme.inputBorder,
};
